import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Funeral for a Friend',
  slug: 'funeral-for-a-friend',
  category: 'Funeral for a Friend',
  date: '2025-05-16',
  image: '',
  excerpt: 'Honoring friendship',
  body: `Honoring friendship

A funeral is an interesting thing. You celebrate the life of the person you loved.

But, if you pay attention, you might notice something deeper. You might notice who you were when you were with that person. And that losing that person, you've lost a piece of yourself that he or she brought out in you that nobody else had access to.

So now you're not just saying goodbye to a friend. You're saying goodbye to a piece of yourself that the friend knew and loved.

Maybe, just maybe, you can honor that friendship by allowing someone new to see that side.

That might be a way to honor the dead. Offer the best of you that he or she brought out in you to the rest of the people in your life.`,
}

export default post
